module.exports = __webpack_public_path__ + "static/img/model-bg4.1ba0a00.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg4.jpg
// module id = AagZ
// module chunks = 0